const AS_FLAGS = [
	'timedOut',
	'noBid',
	'bidWon',
	'bidResponse',
	'renderFailed',
	'renderSuccess',
	'unloadBeforeResponse',
	'isVideo',
	'isNative',
	'_x_unused3',
	'isUniqueResponse',
	'isHighestNonWinningBid',
	'adserverWon',
]; // order must be synced on server-side

const SYSTEM_PARAM_PREFIX = '_sys_';
const PREBID_CONFIGURATION_NAME = 'Prebid Configuration';
const PREBID_CONFIGURATION_DIM = `_${SYSTEM_PARAM_PREFIX}${PREBID_CONFIGURATION_NAME}`;
const GAM_DUPLICATE_PATH_SEPARATOR = '_rlv_dup_';
const MAX_HBA_GET_PARAM_CHARS = 10 * 1024;
const S2S_BIDDER_SUFFIX = '_s2s_alias';

const EVENTS = [
	'auctionInit',
	'auctionEnd',
	'bidAdjustment',
	'bidTimeout',
	'bidRequested',
	'bidResponse',
	'noBid',
	'bidWon',
	'bidderDone',
	'setTargeting',
	'requestBids',
	'addAdUnits',
	'adRenderFailed',
];

const DEFAULT_PLACEMENT_PATH = '?';

module.exports = {
	AS_FLAGS,
	SYSTEM_PARAM_PREFIX,
	PREBID_CONFIGURATION_NAME,
	PREBID_CONFIGURATION_DIM,
	GAM_DUPLICATE_PATH_SEPARATOR,
	EVENTS,
	DEFAULT_PLACEMENT_PATH,
	MAX_HBA_GET_PARAM_CHARS,
	S2S_BIDDER_SUFFIX,
};
